var welcomemodal = {
    badge:"Marival for Agents",
    heading:"Bienvenido a Marival Agents",
    intro1:"Tu recurso todo en uno para vender con confianza, ganar más comisiones, acceder a recompensas exclusivas y crear vacaciones inolvidables que tus clientes recordarán toda la vida.",
    intro2:"Ya sea que reserves vacaciones familiares, escapadas de lujo, bodas de destino, viajes de grupo o reuniones multigeneracionales, aquí encontrarás todo lo que necesitas para hacer crecer tu negocio: desde herramientas de reserva y materiales de marketing hasta capacitación experta y soporte dedicado.",

    whyTitle:"Por qué los Asesores de Viajes eligen Marival",

    benefit1Title:"Aumenta tus ingresos",
    benefit1Text:"Comisiones competitivas, incentivos por bonos y recompensas exclusivas para asesores.",
    benefit2Title:"Enamora a tus clientes",
    benefit2Text:"Resorts premiados que ofrecen experiencias excepcionales y clientes que regresan.",
    benefit3Title:"Reserva con confianza",
    benefit3Text:"Marcas confiables respaldadas por un servicio sobresaliente, gran reputación y calidad constante.",
    benefit4Title:"Todo en un solo lugar",
    benefit4Text:"Motor de reservas, recompensas, capacitación, materiales de marketing y herramientas de venta en un solo portal.",
    benefit5Title:"Soporte experto en ventas",
    benefit5Text:"Tu equipo dedicado de Desarrollo de Negocios está aquí para ayudarte a cerrar más reservas.",
    benefit6Title:"Haz crecer tu negocio",
    benefit6Text:"Más clientes recurrentes, más referencias y alianzas a largo plazo.",

    ctaText:"Continuar",
    closeLabel:"Cerrar"
}
module.exports = welcomemodal
